import React from "react";
import { cls } from "cls";
import ChildOrNull from "~/common/ChildOrNull";
import ShareButtons from "~/common/SocialMediaShare/ShareButtons";
import { SocialMediaShareData } from "~/common/SocialMediaShare/SocialMediaShareData";

// Have to accept additional classes/ID options for now due to
// the differences in CSS/structure for the different FSR resource type pages
interface PostTitleSectionProps {
  additionalContainerClasses?: string;
  additionalHeaderClasses?: string;
  author?: string;
  categories?: {
    url: string;
    name: string;
  }[];
  containerID?: string;
  dateModified: string | undefined;
  displayHeader: string;
  showHeaderTitleTop?: boolean;
  socialMediaButtons?: SocialMediaShareData[];
}

const PostTitleSection = ({
  additionalContainerClasses = "",
  additionalHeaderClasses = "",
  author,
  categories,
  containerID = "",
  dateModified,
  displayHeader,
  socialMediaButtons = [],
  showHeaderTitleTop = true,
}: Readonly<PostTitleSectionProps>) => {
  const dateFormatOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const dateModifiedText =
    dateModified !== undefined
      ? new Date(dateModified).toLocaleDateString("en-us", dateFormatOptions)
      : "Invalid Date";

  return (
    <div
      id={containerID}
      className={cls(
        "mb-6 mt-6 py-0 overflow-hidden",
        additionalContainerClasses
      )}
    >
      <ChildOrNull condition={!!categories?.length}>
        <div className="flex flex-wrap whitespace-pre-wrap">
          {categories?.map((category, index) => {
            return (
              <a
                href={category.url}
                className="category-url block text-green-500 font-semibold text-base leading-tight mb-1"
                key={`category-link-[${category.url}]`}
              >
                {category.name}
                <ChildOrNull condition={index !== categories.length - 1}>
                  {", "}
                </ChildOrNull>
              </a>
            );
          })}
        </div>
      </ChildOrNull>
      <ChildOrNull condition={showHeaderTitleTop}>
        <h1 className={`${additionalHeaderClasses}`}>{displayHeader}</h1>
      </ChildOrNull>
      <span className="last-updated flex flex-wrap font-normal text-gray-600 text-base leading-tight mt-1">
        Last updated on {dateModifiedText}
        <ChildOrNull condition={author !== undefined}>
          <div className="rounded-full w-1 h-1 mx-1 place-self-center bg-gray-300" />
          <span aria-label="author">{author}</span>
        </ChildOrNull>
      </span>
      <ChildOrNull condition={socialMediaButtons.length > 0}>
        <div className="mt-6">
          <ShareButtons {...{ socialMediaButtons }} />
        </div>
      </ChildOrNull>
    </div>
  );
};

export default PostTitleSection;
